import { ProvidersService } from './../../../services/providers.service';
import { Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { UsersService } from '../../../services/users.service';


import * as decode from 'jwt-decode';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit {
  userId: any;
  userToken: any;
  userpass: any = {};
  userInfo: any = {};
  load = true;
  loadBtn = false;
  rolId;
  noProvider: any;

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private usersService: UsersService, private provService: ProvidersService) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    
    this.userId = tokenPayload.Id;
    this.noProvider = tokenPayload.IdProveedor;
    this.rolId = tokenPayload.IdPerfil;

    gralService.changeTextHead('FORMS.ROLE');

    // this.usersService.getUser(tokenPayload.Id, this.userToken).then((data) => {
    //   this.userInfo = data['Entidad'];
    // }, (err) => {
    //   console.log(err);
    //   this.toastr.error(err['error'].msg, 'Error');
    // });
  }

  ngOnInit() {
    this.callInfo();
  }

  saveData(){
    this.loadBtn = true;
    let validedForm = this.validateInfo();
    this.toastr.clear();

    if(validedForm.success){
      let params ={ 
                    Usuario:{
                              "Id":this.userId,
                              "Nombre": this.userInfo.Nombre,
                              "Apellidos": this.userInfo.Apellidos,
                              "AnteriorPassword": null,
                              "NuevoPassword": null,
                              "Email": this.userInfo.Email
                    },
                    ProveedorDireccion:{
                                        "Proveedor": {
                                                      "IdProveedor": this.noProvider,
                                                      "Nombre": this.userInfo.razonSocial ,
                                                      "RFC" : this.userInfo.rfc,
                                                      "Email":  this.userInfo.EmailProveedor
                                        },
                                        "Direccion": {
                                                "Direccion1": null,
                                                "Direccion2": null ,
                                                "Ciudad": null ,
                                                "Estado": null  ,
                                                "Pais": null ,
                                                "CP": this.userInfo.cp
                                        }                          
                    }
                };
      this.loadBtn = false;
      
      this.gralService.validateRfc({rfc:this.userInfo.rfc  }, 'kjsdg876wetkjsdg124putomanu23786' ).then(res=>{
        if(res == 1){
          this.usersService.updateInfo(params, this.userId, this.userToken ).then((res:any)=>{      
            if(res.EsValido){
                
              this.toastr.success('Datos actualizados correctamente', '', {disableTimeOut: true, closeButton: true});
              this.loadBtn = false;
              
            }else{
              this.toastr.error( 'No se pudo actualizar en este momento intentelo más tarde', '', {disableTimeOut: true, closeButton: true});
              this.loadBtn = false;
            }
            
          });
        }else{
          this.loadBtn = false;
          this.toastr.error('El RFC es inválido', '');
          
        }
      });
                
    }else{
      this.loadBtn = false;
      
      this.toastr.error(validedForm.msg, '');
    }

  }

  savePass(){
    if(!this.userpass.old || !this.userpass.new){
      this.toastr.error('Favor de agregar las contraseñas', 'Cambiar contraseña');
      return;
    }

    if(this.userpass.confirm != this.userpass.new){
      this.toastr.error('La nueva contraseña no coincide con la confirmación', 'Cambiar contraseña');
      return;
    }

    this.loadBtn = true;
    const params = {'AnteriorPassword': this.userpass.old, 'NuevoPassword': this.userpass.new};
    this.usersService.changePassword(this.userId, params, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.toastr.success('Contraseña modificada correctamente', 'Cambiar contraseña');
      }else{
        this.toastr.error(data['MensajeUsuario'], 'Cambiar contraseña');
        return;
      }
    }, (err) => {
      this.loadBtn = false;
      console.log(err);
      this.toastr.error(err['error'].msg, 'Error');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  validateEmail(email){
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  callInfo(){
    this.provService.getInfoProviderFirstSession(this.userId, this.userToken).then((res:any) =>{
      console.log(res.Entidad);
      if(res.Entidad){
        const info = res.Entidad;
        
        if(info.ProveedorDireccion != null){
          this.userInfo.razonSocial     = info.ProveedorDireccion.Proveedor.Nombre;
          this.userInfo.rfc             = info.ProveedorDireccion.Proveedor.RFC;
          this.userInfo.EmailProveedor  = info.ProveedorDireccion.Proveedor.Email;
          this.userInfo.cp              = info.ProveedorDireccion.Direccion.CP
          
        } 
          this.userInfo.Nombre          = info.Usuario.Nombre;
          this.userInfo.Apellidos       = info.Usuario.Apellidos;
          this.userInfo.Email           = info.Usuario.Email;
      }
    });
  }

  validateInfo(){
    if(this.rolId == 3){  
      if(this.userInfo.razonSocial == '' || this.userInfo.razonSocial == undefined ){ return {success: false, msg: "Debes ingresar el campo razón social"  }}
      if(this.userInfo.rfc == ''    || this.userInfo.rfc == undefined ){ return {success: false, msg: "Debes ingresar el campo RFC"  }}
      if(this.userInfo.EmailProveedor == ''    || this.userInfo.EmailProveedor == undefined ){ return {success: false, msg: "Debes ingresar el campo correo proveedor" } }

      if(!this.validateEmail(this.userInfo.EmailProveedor) ){ return {success: false, msg: "Debes ingresar un correo válido" } }        
      if(this.userInfo.cp == ''     || this.userInfo.cp == undefined ){ return {success: false, msg: "Debes ingresar el campo código postal"  }}  
    }
    
    if(this.userInfo.Nombre == ''  || this.userInfo.Nombre == undefined ){ return {success: false, msg: "Debes ingresar el campo nombre" }}
    if(this.userInfo.Email == ''  || this.userInfo.Email == undefined ){ return {success: false, msg: "Debes ingresar el campo email" }}
    if(!this.validateEmail(this.userInfo.Email) ){return {success: false, msg: "Debes ingresar un correo válido" }}

    return {success: true, msg: "Todo es válido"};
  }

}
